/* eslint-disable */
import React, { useEffect } from 'react';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { MyDocuments } from 'components/my-documents';

export const MyDocumentsPage: React.FC = () => {

    useEffect(() => {
        document.title = 'Mes documents';
    }, []);

    return (
        <ContentSection pageWrapSize="medium">
            <MyDocuments />
        </ContentSection>
    );
};
